module.exports = __webpack_public_path__ + "img/退货出库.1c6c2f47.svg";